import { FIREBERRY_METADATA_TOKEN_STORAGE_KEY } from 'constants/fireberryMetadata';
import { store } from 'store';
import type { CompanyModel } from 'types/company/company';

function readLegacyLocalToken(): string {
  if (typeof window === 'undefined') return '';
  try {
    return (window.localStorage.getItem(FIREBERRY_METADATA_TOKEN_STORAGE_KEY) ?? '').trim();
  } catch {
    return '';
  }
}

/** מנרמל שמות שדה חלופיים מתשובת GetCompanyDetails */
export function extractAdminTokenIdFromCompany(
  company: CompanyModel | Record<string, unknown> | null | undefined,
): string {
  if (!company || typeof company !== 'object') return '';
  const raw = company as Record<string, unknown>;
  return String(
    raw.AdminTokenId ?? raw.adminTokenId ?? raw.AdminToken ?? raw.adminToken ?? '',
  ).trim();
}

/** שומר עותק מקומי לתאימות לאחור (לפני מעבר ל־Redux בלבד) */
export function syncFireberryMetadataTokenCache(token: string): void {
  if (typeof window === 'undefined') return;
  const trimmed = token.trim();
  try {
    if (trimmed) {
      window.localStorage.setItem(FIREBERRY_METADATA_TOKEN_STORAGE_KEY, trimmed);
    } else {
      window.localStorage.removeItem(FIREBERRY_METADATA_TOKEN_STORAGE_KEY);
    }
  } catch {
    /* quota / private mode */
  }
}

/** טוקן פיירברי של החברה — מ־GetCompanyDetails, עם גיבוי localStorage */
export function getCompanyFireberryToken(): string {
  const fromCompany = extractAdminTokenIdFromCompany(store.getState().company);
  if (fromCompany) return fromCompany;
  return readLegacyLocalToken();
}

/** @deprecated השתמשו ב־getCompanyFireberryToken */
export function getFireberryMetadataToken(): string {
  return getCompanyFireberryToken();
}

/** @deprecated הטוקן מנוהל בהגדרות פיירברי (פרטי חברה) — נשמר דרך SetCompanyConfig */
export function setFireberryMetadataToken(token: string): void {
  syncFireberryMetadataTokenCache(token);
}
